import PropTypes from 'prop-types';
// @mui
import { Box, Stack, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';
// styles
import { StyledRoot, StyledToolbar } from './styles/headerStyles';

export default function Header({ onOpenNav }) {
  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          sx={{ backdropFilter: 'blur(6px)' }}
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
